import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Suppliers() {
    const role = localStorage.getItem("role") || "user";
    const isAdmin = role === "admin";
    const [suppliers, setSuppliers] = useState([]);
    const [newSupplier, setNewSupplier] = useState({ name: '', contact: '', address: '', email: '', opening_balance: 0 });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const fetchSuppliers = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/suppliers`);
            setSuppliers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSaveSupplier = async (e) => {
        e.preventDefault();
        try {
            if (editingId) {
                if (!isAdmin) return alert("Only admin can update records");
                await axios.put(`${getApiUrl()}/suppliers/${editingId}`, newSupplier);
            } else {
                await axios.post(`${getApiUrl()}/suppliers`, newSupplier);
            }
            setNewSupplier({ name: '', contact: '', address: '', email: '', opening_balance: 0 });
            setEditingId(null);
            fetchSuppliers();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this supplier?")) return;
        try {
            await axios.delete(`${getApiUrl()}/suppliers/${id}`);
            fetchSuppliers();
        } catch (err) {
            console.error(err);
            const message =
                err?.response?.data?.message ||
                err?.response?.data?.sqlMessage ||
                err?.response?.data?.code ||
                "Failed to delete supplier";
            alert(message);
        }
    };

    const startEdit = (s) => {
        setEditingId(s.id);
        setNewSupplier({
            name: s.name || '',
            contact: s.contact || '',
            address: s.address || '',
            email: s.email || '',
            opening_balance: parseFloat(s.opening_balance) || 0
        });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setNewSupplier({ name: '', contact: '', address: '', email: '', opening_balance: 0 });
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Suppliers</h2>
                <form onSubmit={handleSaveSupplier} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Supplier Name" value={newSupplier.name} onChange={e => setNewSupplier({...newSupplier, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Contact" value={newSupplier.contact} onChange={e => setNewSupplier({...newSupplier, contact: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Address" value={newSupplier.address} onChange={e => setNewSupplier({...newSupplier, address: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="email" className="form-control" placeholder="Email" value={newSupplier.email} onChange={e => setNewSupplier({...newSupplier, email: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        {isAdmin && (
                            <div className="col-md-3">
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Opening Balance"
                                    value={newSupplier.opening_balance}
                                    onChange={e => setNewSupplier({ ...newSupplier, opening_balance: parseFloat(e.target.value) || 0 })}
                                    onFocus={(e) => e.target.select()}
                                />
                            </div>
                        )}
                        <div className="col-md-2 d-grid">
                            <button type="submit" className={`btn ${editingId ? 'btn-warning' : 'btn-primary'}`}>{editingId ? 'Update' : 'Add'}</button>
                        </div>
                        {editingId && (
                            <div className="col-md-2 d-grid">
                                <button type="button" className="btn btn-secondary" onClick={cancelEdit}>Cancel</button>
                            </div>
                        )}
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Contact</th>
                                <th>Address</th>
                                <th>Email</th>
                                {isAdmin && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {suppliers.map(s => (
                                <tr key={s.id}>
                                    <td>{s.name}</td>
                                    <td>{s.contact}</td>
                                    <td>{s.address}</td>
                                    <td>{s.email}</td>
                                    {isAdmin && (
                                        <td>
                                            <button type="button" className="btn btn-warning btn-sm me-1" onClick={() => startEdit(s)}>Edit</button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(s.id)}>Delete</button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Suppliers;
